import React from 'react';
import * as S from './style';
import GoogleIcon from '~images/icons/google_icon.svg'
import AppleIcon from '~images/icons/apple_icon.svg'
import Image from '../common/Image';
import { getCookie, getItemFromSessionStorage, setCookieWithAge } from '../../../utils/web-helper';
import { trackToGtmFE } from '../../../utils/gtm-event-common';

const SocialSignupGroup = (props) => {
  const { SocialLinks } = props
  return(
    <S.SocialSignupGroupContainer>
      {SocialLinks.links.map(link =>
        <SocialSignupLink
          link={link}
          userType={SocialLinks.userType}
          key={"SocialSignupLink_" + link}
          setShowSuspectedPopup={props.setShowSuspectedPopup}
        />
      )}
    </S.SocialSignupGroupContainer>
  )
}

const timeZone = getCookie("timezone")

const socialLinkData = {
  google: {
    url: "/users/auth/google_oauth2?source=web&time_zone="+timeZone+"&type=",
    icon: GoogleIcon,
    text: "Google"
  },
  apple: {
    url: "/users/auth/apple?source=web&time_zone="+timeZone+"&type=",
    icon: AppleIcon,
    text: "Apple"
  }
}


const SocialSignupLink = (props) => {
  const { link, userType } = props
  const gotoURL = socialLinkData[link].url + userType

  const getMarketingContextParams = () => {
    let landing_page_url = getItemFromSessionStorage('landing_page_url') || JSON.stringify(window.location.pathname)
    let ad_group_id = getItemFromSessionStorage('ad_group_id')?.[0] || 'NA'
    return `&landing_page_url=${landing_page_url}&ad_group_id=${ad_group_id}`
  }
  const clickHandler = () => {
    localStorage.setItem('parent_signup_method', link);
    let marketingContextParams = getMarketingContextParams()
    let redirectUrl = gotoURL + "&tnc_privacy=false&email_preference=false" + marketingContextParams
    typeof sendAnalyticsEvent !=="undefined" && sendAnalyticsEvent($("#socialSignup_"+link));
    typeof googleAnalyticsEvent !=="undefined" && googleAnalyticsEvent('started signing up', link,'parent')
    trackAnalyticsEvent('User agent info', {'User Agent': window.navigator.userAgent});
    const clickText = link == 'google' ? 'Sign Up with Google' : 'Sign Up with Apple';
    trackToGtmFE('clicked_parent_signup_cta',{'Click Text': clickText, 'Click URL': redirectUrl})
    // [AI GENERATED CODE] — Set pending source before OAuth redirect so createSession picks it up on return.
    if (typeof window.MUS !== 'undefined') window.MUS.setPendingSource('oauth');
    window.top.location = redirectUrl;
  }
  
  return(
    <S.SocialSignupLinkButton id={"socialSignup_"+link} link={link} onClick={clickHandler} data-frompage="Signup" data-testid={"socialSignup_"+link}>
      <S.SocialLinkImage link={link}>
        <Image src={socialLinkData[link].icon} alt={`Btn ${link}`}/>
      </S.SocialLinkImage>
      <S.SocialLinkText>Sign Up with {socialLinkData[link].text}</S.SocialLinkText>
    </S.SocialSignupLinkButton>
  )
}

export default SocialSignupGroup;